module.exports = __webpack_public_path__ + "static/media/Buho_PrintBck.d25e2dc0.svg";